import MockAdapter from 'axios-mock-adapter'

export const resolvePromises = () => new Promise(resolve => setImmediate(resolve))

export const fakeAlertMixin = mock => ({
  created: function () {
    this.alertModal = mock
  }
})

export const createNetworkMock = axios => new MockAdapter(axios)
